// Public configuration shared by the apps. Everything here is safe to ship in browser code.
// Secret keys (Supabase service role, R2, Stripe, Resend) never go in this repo: they live in
// Cloudflare's environment variables and are read by the API Worker at runtime.

export const SUPABASE_URL = 'https://ukqvxhxjsqtjgjaaghfg.supabase.co';

/** Supabase publishable (anon) key. Row level security protects the data, not this key. */
export const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_r8v-AC2fLH6sf6ChAv0Wmg_ockoXxx7';

/** Public base URL of the R2 bucket that holds published tours. */
export const MEDIA_BASE = 'https://media.archviewvr.com';

/** R2 bucket name (bound to the API Worker; the Worker holds the access keys). */
export const R2_BUCKET = 'archviewvr-media';

/** Stripe: "ArchviewVR project", $29 AUD a month. Live since 4 Oct 2026 (test price was price_1UMM2MLWjy1pnmpsAXFsqyu9). */
export const STRIPE = {
  productId: 'prod_VN6EfpcpQyL8iS',
  priceId: 'price_1UMdzWPxnMYBLj6Hz1nYH2DP',
  mode: 'live' as 'test' | 'live',
};

/**
 * Addresses. archviewvr.com is the marketing website. Everything else lives on one Pages project at
 * dashboard.archviewvr.com: the studio dashboard at /, tours at /t/<slug>, the API at /api.
 */
export const SITE_URL = 'https://archviewvr.com';
export const APP_URL = 'https://dashboard.archviewvr.com';
export const API_BASE = 'https://dashboard.archviewvr.com/api';
export const tourUrl = (slug: string) => `${APP_URL}/t/${slug}`;

/** Plan rules, mirrored by the database. */
export const PLAN = {
  priceAud: 29,
  storageLimitBytes: 500 * 1024 * 1024,
  /** Storage limits an admin can give a project (500 MB is the default). */
  storageOptions: [500 * 1024 ** 2, 1024 ** 3, 2 * 1024 ** 3, 3 * 1024 ** 3, 5 * 1024 ** 3, 10 * 1024 ** 3],
  supportEmail: 'contact@rdvis.com',
  trialPanoLimit: 10,
} as const;
